<app-masthead class="sticky top-0 z-50"></app-masthead>

<main>
  <router-outlet></router-outlet>
</main>

<app-snack-bar></app-snack-bar>

<app-footer></app-footer>

@if (requiresBirthdateEntry()) {
<app-birthdate-modal></app-birthdate-modal>
}